import classify from '../../helpers/classify';

const getOptions = (containerEl: HTMLElement, optionsClass: string): any => {
  try {
    return JSON.parse(containerEl.querySelector(classify(optionsClass))?.textContent || '');
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export default getOptions;
